export default __webpack_public_path__ + "static/media/CollapseArrow.d81330d3.svg";